import React from 'react';
import './Skills.css';

const languages = [
  'Python', 'Java', 'C / C++', 'Go', 'JavaScript (ES6+)',
  'SQL (PostgreSQL)', 'R', 'HTML / CSS',
];

const frameworks = [
  'React', 'React Native', 'FastAPI', 'Flask', 'Node.js',
  'SQLAlchemy', 'Canvas API', 'Docker', 'Git', 'Unity', 'JUnit',
];

const security = [
  'Cryptography', 'Authentication', 'Access Control', 'Security Auditing', 'CSP',
];

export default function Skills() {
  return (
    <section className="skills" id="skills">
      <div className="skills__inner">

        <div className="section-header">
          <p className="section-label">Capabilities</p>
          <h2 className="section-title">Technical Skills</h2>
          <div className="section-rule">
            <span className="section-rule__line" />
            <span className="section-rule__diamond" />
            <span className="section-rule__line" />
          </div>
        </div>

        <div className="skills__block">
          {/* Languages */}
          <div className="skills__row">
            <h3 className="skills__row-label">Languages</h3>
            <div className="skills__tags">
              {languages.map(s => (
                <span className="skills__tag" key={s}>{s}</span>
              ))}
            </div>
          </div>

          <div className="skills__divider" />

          {/* Frameworks & Tools */}
          <div className="skills__row">
            <h3 className="skills__row-label">Frameworks &amp; Tools</h3>
            <div className="skills__tags">
              {frameworks.map(s => (
                <span className="skills__tag" key={s}>{s}</span>
              ))}
            </div>
          </div>

          <div className="skills__divider" />

          {/* Security */}
          <div className="skills__row">
            <h3 className="skills__row-label">Security</h3>
            <div className="skills__tags">
              {security.map(s => (
                <span className="skills__tag" key={s}>{s}</span>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}